export default (value: string) => {
  return /true/i.test(value);
};
